<form [formGroup]="farmForm" (ngSubmit)="changeFarmName()">
    <div class="flex-column">
        <div class="flex-1">
            <h2  class="label-header" style="font-weight: bold; font-size: medium;">{{ 'EDIT-FARM-DIALOG.FARM-NAME' | translate }}</h2>
            <br />
            <mat-form-field style="width: 100%;" appearance="outline">
                <input [(ngModel)]="newFarmName" matInput type="text" placeholder="" formControlName="name" >
                <!-- <mat-error *ngFor="let validation of farm_validation_messages.name"> -->
                    <mat-error class="error-message" *ngIf="farmForm.get('name').hasError('required') &&
                    (farmForm.get('name').dirty || farmForm.get('name').touched)">
                        {{ErrorMessage}}
                    </mat-error>
                <!-- </mat-error> -->
            </mat-form-field>
            <br />
        </div>
        <div class="flex-1 flex-row space-around-center" style="margin-top: 10px;">
            <button mat-flat-button style="width: 40%;" (click)="cancel()" type="button" class="cancel-rename-farm">{{
                'ADD-FARM-DIALOG.CANCEL' |
                    translate }}</button>
            <button mat-flat-button style="width: 40%;" type="submit" class="buttons field-add-btn" [disabled]="!farmForm.valid">{{ 'EDIT-FARM-DIALOG.UPDATE-FARM-NAME' |
                translate }}</button>
        </div>
    </div>
</form>
